import { render, staticRenderFns } from "./PurchaseOrderDetails.vue?vue&type=template&id=627442bc&scoped=true"
import script from "./PurchaseOrderDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetails.vue?vue&type=style&index=0&id=627442bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627442bc",
  null
  
)

export default component.exports